import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      padding: '30px 20px',
      marginTop: '50px',
      textAlign: 'center'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}>
        {/* Contact Section */}
        <div style={{
          fontSize: '16px',
          marginBottom: '10px'
        }}>
          <a 
            href="tel:+447442110312"
            style={{
              color: 'white',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 20px',
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '8px',
              transition: 'all 0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
            onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          >
            📞 Call/WhatsApp us for affordable Digital Solutions: +44 744 211 0312
          </a>
        </div>

        {/* Copyright Section */}
        <div style={{
          fontSize: '14px',
          opacity: 0.9
        }}>
          Designed and developed by{' '}
          <a 
            href="https://envicblue.co.uk/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              color: 'white',
              fontWeight: 'bold',
              textDecoration: 'underline'
            }}
          >
            Envicblue International
          </a>
          . All rights reserved by Envicblue © {currentYear}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
